"use client"
import React, { useEffect, useState } from "react";

import {
  Card,
  CardBody,
  Typography,
  Button,
  List,
  ListItem,
  Avatar,
  IconButton,
  Rating,
  Breadcrumbs,
} from "@material-tailwind/react";
import { Title, TopProducts } from "@/components";
import Image from "next/image";
import { MdOutlineShoppingCart } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { getProductStart, getProductSuccess } from "@/GlobalRedux/Slices/allProducts";
import { AddToCart, EditCart, getAllProducts, getCartItem } from "@/API/response";
import { errorNotify } from "../Toast";
import { rgbDataURL } from "@/utils/rgbDtaurl";
import { FaMinus, FaPlus } from "react-icons/fa";
import { getCartItemStart, getCartItemSuccess, updateCart } from "@/GlobalRedux/Slices/allCartItems";
import { addToCart } from "@/GlobalRedux/Slices/addToCart";
import ProductReviews from "./ReviewSection";
import Link from "next/link";

export function ProductDetail({ title, image, url, price, description, allFile, category, comparePrice, onAddToCart, onAddToCartInSm, cartData, quantity, decreaseCount, addCount, count, productID, ReviewData }) {
  // console.log("ReviewData ===>>>",ReviewData)
  const [activeButton, setActiveButton] = useState(null);
  const dispatch = useDispatch()
  const { allProducts, isLoader } = useSelector((state) => state.allproducts)
  const filteredProducts = allProducts?.filter((item) => item.category == category)
  // Function to handle button click and set the active button
  const handleButtonClick = (buttonIndex) => {
    setActiveButton(buttonIndex);
  };
  // for discount % 
  // let discount = ((comparePrice - price) / comparePrice) * 100
  // let result = Math.round(discount)
  // get cart products
  const getCartProducts = async () => {
    const getSessionId = localStorage.getItem("sessionId")
    try {
      dispatch(getCartItemStart())
      const response = await getCartItem("cart/getCart", getSessionId);
      dispatch(getCartItemSuccess(response))
    } catch (error) {
      console.log(error)
    }
  }
  // get all products 
  const getAllProduct = async () => {
    // const route = `products?category=${category}`;  
    const route = `products`;
    try {
      dispatch(getProductStart())
      const response = await getAllProducts(route)
      dispatch(getProductSuccess(response))
    } catch (error) {
      errorNotify(error || response.message)
    }
  }

  // all review star show 
  const { allReviews, } = useSelector((state) => state.allReview);

  const totalReviews = allReviews?.length || 0; // Total number of reviews
  const totalStars = allReviews?.reduce((acc, review) => acc + review.star, 0) || 0;
  const averageRating = totalReviews > 0 ? totalStars / totalReviews : 0; // Average rating

  // Ensure the rating doesn't exceed 5
  const clampedRating = Math.min(averageRating, 5);

  const fullStars = Math.floor(clampedRating); // Full stars
  const hasHalfStar = clampedRating % 1 !== 0 && clampedRating < 5;  // Check if half star is needed
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0); // Remaining empty stars

  // console.log("fullStars", fullStars);
  // console.log("hasHalfStar", hasHalfStar);
  // console.log("emptyStars", emptyStars);

  const [active, setActive] = React.useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const handleClick = (index, img) => {
    setActiveIndex(index)
    setActive(img)
  }

  useEffect(() => {
    getAllProduct()
    getCartProducts()
  }, [])
  return (
    <div>
        <Breadcrumbs className="mt-4 flex items-center text-darkBlack text-sm font-sans">
        <Link href="/" className="flex items-center justify-center gap-1 opacity-80 hover:opacity-100 hover:scale-105 transition">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4 text-darkBlack"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
        </svg>
        <span>Home</span>
      </Link>
      <a href="/products" className="opacity-80 hover:opacity-100 hover:underline">
        <span>Products</span>
      </a>
      <a href="#" className="font-semibold text-darkBlack hidden lg:flex ">{title}</a>
      <a href="#" className="font-semibold text-darkBlack  lg:hidden flex">{title?.slice(0,12)}..</a>
    </Breadcrumbs>
   
      <div className=" flex flex-col lg:flex-row justify-around  gap-4 px-2 py-5">
        <div className="flex-col w-full item-center justify-center h-full flex ">
          <div className="flex h-96 lg:h-[500px]  w-full overflow-hidden justify-center">
            <Image
              className="h-full w-full border-2 bg-white border-black rounded-lg object-fit sm:object-contain lg:object-fill"
              src={active == null ? url : active}
              alt={title}
              width={1000}
              height={1000}
              layout="intrinsic" // Ensures the image maintains its aspect ratio within the fixed height
              placeholder="blur"
              blurDataURL={rgbDataURL(234, 225, 221)}
            />
          </div>

          <div className="flex  gap-3 justify-start mx-auto w-full sm:w-96 md:w-full   overflow-x-auto whitespace-nowrap overflow-hidden items-center  py-2">
            {allFile?.map((img, index) => (
              <div key={index} className="shrink-0">
                <img
                  onClick={() => handleClick(index, img)}
                  src={img}
                  width={1000}
                  height={1000}
                  blurDataURL={rgbDataURL(234, 225, 221)}
                  placeholder="blur"
                  // loading="lazy"
                  className={activeIndex === index ? "border-2 border-black h-20 max-w-full w-32 cursor-pointer bg-white rounded-lg object-fit object-center" : "h-20 max-w-full w-32 cursor-pointer rounded-lg object-fit object-center bg-white"}
                  alt="gallery-image"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="">
          <Card className=" lg:w-96 max-h-screen overflow-y-auto w-full ">
            <CardBody>
              <Typography variant="h4" color="blue-gray" className="mb-2 text-2xl myfontbold">
                {title}
              </Typography>
              <span className="flex  items-center">
                <div className="flex py-2 items-center">
                  {/* Full Stars */}
                  {[...Array(fullStars)].map((_, index) => (
                    <span key={`full-${index}`} className="text-yellow-700 text-2xl ">★</span> // Filled star
                  ))}

                  {/* Half Star */}
                  {hasHalfStar && <span key="half" className="text-yellow-600 text-2xl">☆</span>}

                  {/* Empty Stars */}
                  {[...Array(emptyStars)].map((_, index) => (
                    <span key={`empty-${index}`} className="text-gray-400 text-2xl">★</span> // Empty star
                  ))}

                  {/* Average Rating Text */}
                  <a href="#reviewSection">
                    <div className="text-gray-500 text-sm ml-2">
                      {clampedRating.toFixed(1)} / 5 ({totalReviews} reviews)
                    </div>
                  </a>
                </div>
              </span>
              <span className="flex items-center justify-between py-2">

                <span className="font-body text-xl flex items-center md:text-2xl">
                  Rs {price}  <del className="text-lg  text-red-400  px-2">RS {comparePrice}</del>
                </span>
                <span>
                  <div className="flex items-center gap-4 ">
                    <button onClick={decreaseCount} className="p-2 bg-gray-200 rounded-full">
                      <FaMinus />
                    </button>
                    <span className="mx-2.5">{count}</span>
                    <button
                      onClick={count >= 5 ? undefined : addCount}
                      className={`p-2 bg-gray-200 rounded-full ${count >= 5 ? "cursor-not-allowed" : ""}`}
                      disabled={count >= 5}
                    >
                      <FaPlus />
                    </button>
                  </div>
                </span>

              </span>
              <span className="flex">
                <span className={
                  quantity == 0 || quantity == undefined
                    ? "text-red-400 flex gap-2"
                    : quantity <= 10
                      ? "text-yellow-800 font-semibold flex gap-2"
                      : "text-green-400 font-body flex gap-2"
                }>
                  {quantity == 0 || quantity == undefined
                    ? "Out Of Stock"
                    : quantity <= 10
                      ? "Hurry Up! Low In Stock"
                      : "In Stock"}
                  <span className={quantity > 10 || quantity === undefined ? "hidden" : "flex"}>
                    {`(${quantity})`}
                  </span>
                </span>
              </span>


              <span className="flex ">
                <Button
                  fullWidth
                  size="sm"
                  disabled={quantity === 0 || undefined}
                  className={quantity == 0 || undefined ? "opacity-100 my-5 hidden w-full h-12 text-lg sm:text-xl lg:flex justify-center items-center text-center bg-secondary hover:bg-black  text-pureWhite gap-2 px-4 hover:cursor-not-allowed" : "opacity-100 my-5 hidden w-full h-12 text-lg sm:text-xl lg:flex justify-center items-center text-center bg-secondary hover:bg-black  text-pureWhite gap-2 px-4"}
                  onClick={onAddToCart}
                >
                  {quantity == 0 || undefined ? "Sold Out" : "Add To Cart"}
                  <span>
                    <MdOutlineShoppingCart className="h-6 w-6 text-pureWhite" />
                  </span>
                </Button>
              </span>
              <span className="flex ">
                <Button
                  fullWidth
                  disabled={quantity === 0 || undefined}
                  size="sm"
                  className={quantity == 0 ? "opacity-100 my-5 lg:hidden w-full h-12 text-lg sm:text-xl flex justify-center items-center text-center bg-secondary hover:bg-black  text-pureWhite gap-2 px-4 hover:cursor-not-allowed" : "opacity-100 my-5 lg:hidden w-full h-12 text-lg sm:text-xl flex justify-center items-center text-center bg-secondary hover:bg-black  text-pureWhite gap-2 px-4"}
                  onClick={onAddToCartInSm}
                >
                  Add To Cart
                  <span>
                    <MdOutlineShoppingCart className="h-6 w-6 text-pureWhite" />
                  </span>
                </Button>
              </span>
              <Typography className="myfont">
                {description?.split(/\r\n/).map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </Typography>
              <Typography className="my-4 border-b-4 border-gray-500">

              </Typography>
              <Card className="w-full border-2 shadow-none">
                <List>
                  <ListItem>
                    <span>
                      <Avatar
                        src={"/Images/fastdelivery.png"}
                        alt="avatar"
                        className="p-0.5"
                      />
                    </span>
                    <span className="myfont text-sm ">
                      Delivery Charges<br /> <hr />
                      Depend on the location
                    </span>
                  </ListItem>
                  <ListItem>
                    <span>
                      <Avatar
                        src={"https://img.freepik.com/free-vector/cycle-circle-arrow_78370-7801.jpg?t=st=1732692464~exp=1732696064~hmac=7581b85d9a68572619df4abc015c0e9820cb4032fd36cb08539473658c661f98&w=826"}
                        alt="avatar"
                        className="p-0.5"
                      />
                    </span>
                    <span className="myfont text-sm">
                      Return Delivery <br /> <hr />
                      Free 7 Days Delivery Returns.
                    </span>
                  </ListItem>
                </List>
              </Card>
            </CardBody>

          </Card>
        </div>
      </div>
      <span className="py-4">
        <Title title="You May Also Like" Subtitle={category} />
        <TopProducts filterData={filteredProducts} />
      </span>
      <span id="reviewSection">
        <ProductReviews ReviewData={ReviewData} productID={productID} />
      </span>

    </div>
  );
}